<section style="margin-top: -20px;">
  <div class="row text-left">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">

            <div class="row">
              <div [class]="parametrosTabla.clasePaginator">
                <button type="button" class="btn btn-info" *ngIf="parametrosTabla.botonAgregarNuevo===true"
                        (click)="emit(this.constants.AGREGAR)"><i
                  class="ft-plus mr-1"></i>{{parametrosTabla.botonAgregar.titulo}}</button>

                <button class="btn btn-success"
                        *ngIf="parametrosTabla.botonExportar!=undefined && parametrosTabla.botonExportar==true"
                        style="margin-left: 1px;" type="button" title="Exportar tabla en Excel" (click)="exportTable()">
                  <fa-icon [icon]="iconoExcel" size="lg"></fa-icon>
                </button>

                <button class="btn btn-secondary"
                        *ngIf="parametrosTabla.botonExportarGeneral!=undefined && parametrosTabla.botonExportarGeneral==true"
                        style="margin-left: 1px;" type="button" title="Reporte General" (click)="exportTableColumnas()">
                  <fa-icon [icon]="iconoExcel" size="lg"></fa-icon>
                </button>

                <button class="btn btn-info"
                        *ngIf="parametrosTabla.botonPDF!=undefined && parametrosTabla.botonPDF==true"
                        style="margin-left: 1px;" type="button" title="Generar PDF" (click)="emit(this.constants.PDF)">
                  <fa-icon [icon]="iconoPdf" size="lg"></fa-icon>
                </button>

                <button class="btn btn-warning"
                        *ngIf="parametrosTabla.botonActualizar!=undefined && parametrosTabla.botonActualizar==true"
                        title="Actualizar datos en tabla" style="margin-left: 1px;" type="button"
                        (click)="emit(this.constants.ACTUALIZAR_TABLA)">
                  <i class="ft-refresh-ccw"></i>
                </button>

                <div *ngIf="parametrosTabla.botonDescarga!=undefined && parametrosTabla.botonDescarga==true"
                     style="display: inline;">
                  <button class="btn btn-dark" title="Descarga"
                          style="margin-left: 1px;" type="button" (click)="emit(this.constants.DESCARGAR)">
                    <i class="ft-download"></i>
                  </button>
                </div>


              </div>

              <div [class]="parametrosTabla.clasePaginator">
                <mat-paginator #idpaginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                               [pageIndex]="pageIndex" (page)="pageEvent = handlePage($event)"></mat-paginator>
              </div>
            </div>

            <mat-form-field appearance="fill" style="width: 100%;">
              <mat-label>Buscar....</mat-label>
              <input matInput (keyup)="filterTable($event)" placeholder="Buscar" #input autocomplete="off">
            </mat-form-field>

            <div #idExportar style="overflow-x: auto;">
              <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
                     class="example-container mat-elevation-z8" style="width: 100%;">

                <div *ngFor="let columna of displayedColumns; let i = index ">

                  <ng-container matColumnDef="{{columna}}">


                    <div *ngIf="this.formatColumn[i]!==this.constants.CONTROL">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{dataNames[i]}}</th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.TEXT">
                      <td mat-cell *matCellDef="let element"
                          [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)">{{element[displayedColumns[i]]}}</td>
                      <td mat-footer-cell *matFooterCellDef></td>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.NUMBER">
                      <td style="text-align: center; border:solid #2f8be6 2px;" mat-cell *matCellDef="let element"
                          [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)">{{element[displayedColumns[i]] | number: '1.2-2'}}</td>
                      <th mat-footer-cell *matFooterCellDef
                          style="text-align: right">{{sumTotal(columna) === 0 ? '-' : (sumTotal(columna)| number:'1.2-2')}} </th>

                    </div>


                    <div *ngIf="this.formatColumn[i]===this.constants.CURRENCY">
                      <td mat-cell *matCellDef="let element" [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)"
                          style="text-align: right; border:solid #EB984E 2px;">
                        <div *ngIf="displayCurrency(element,columna)">
                          {{element[displayedColumns[i]] | currency: 'MXN'}}
                        </div>
                      </td>
                      <th mat-footer-cell *matFooterCellDef
                          style="text-align: right">{{sumTotal(columna) === 0 ? '-' : '$' + (sumTotal(columna)| number:'1.2-2')}} </th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.DATE">
                      <td mat-cell *matCellDef="let element"
                          [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)">{{element[displayedColumns[i]] | date:'dd-MMM-yyyy'}}</td>
                      <td mat-footer-cell *matFooterCellDef></td>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.DATETIME">
                      <td mat-cell *matCellDef="let element"
                          [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)">{{element[displayedColumns[i]] | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
                      <td mat-footer-cell *matFooterCellDef></td>
                    </div>

                    <!-- Controles -->
                    <div *ngIf="this.formatColumn[i]===this.constants.CONTROL">
                      <th mat-header-cell *matHeaderCellDef></th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.CONTROL">
                      <td mat-cell *matCellDef="let element" style="width: 5px !important;">
                        <a class="p-0" (click)="emit(columna,element)"
                           *ngIf="displayColumn(element,columna) && isGranted(columna)">
                          <i [title]="columna" [class]="setIconColumn(columna)"></i>
                        </a>
                      </td>
                      <td mat-footer-cell *matFooterCellDef></td>
                    </div>

                  </ng-container>
                </div>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
                    [ngClass]="{alternate: even}"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="20" style="text-align: center;">No hay informacion para
                    mostrar {{input.value}}</td>
                </tr>

              </table>

              <div *ngIf="this.parametrosTabla.dataSource.length > 0 && this.isLoading"
                   style="display: flex; justify-content: center; align-items: center; margin-top: 15px;">
                <mat-progress-spinner
                  color="primary"
                  mode="indeterminate"
                  [diameter]="30">
                </mat-progress-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<ngx-spinner style="color:#ffffff;">Cargando</ngx-spinner>


<div class="contextmenu" [ngStyle]="this.rightPanelStyle" (clickOutside)="closeContextMenu()"
     (mouseleave)="closeContextMenu()">
  <ul class="menu">
    <div *ngFor="let columna of displayedColumns; let i = index ">
      <li
        *ngIf="this.formatColumn[i]===this.constants.CONTROL &&
        this.optionSelectedMenuContext!== undefined &&
        displayOptionMenuContext(columna) && isGranted(columna)">
        <a (click)="emit(columna,this.optionSelectedMenuContext)">
          <i [title]="columna" [class]="setIconColumn(columna)"></i>{{columna}}
        </a>
      </li>
    </div>
  </ul>
</div>
